module.exports = __webpack_public_path__ + "static/img/card5.0ccd06b0.png";